export const DIALOG_SETTINGS = {
  offset: 8,
  maxWidth: 288,
};
